<div class="emergencia-page">
    <div class="container py-4">

        <!-- Alerta informativa -->
        <div class="alerta-proposito mb-4" role="alert">
            <div class="d-flex gap-3">
                <i class="bi bi-exclamation-triangle-fill alerta-icono flex-shrink-0"></i>
                <div>
                    <h5 class="alerta-titulo mb-2">Plataforma de Respuesta Inmediata INCES</h5>
                    <p class="alerta-texto mb-0">
                        <strong>Propósito:</strong>
                        Disponer de una plataforma tecnológica de respuesta inmediata para el censo
                        post-contingencia del personal del INCES ante el desastre natural del Terremoto
                        de Venezuela (24Jun2026), permitiendo conocer en tiempo real la ubicación,
                        estado de salud y condiciones habitacionales de los trabajadores afectados.
                    </p>
                </div>
            </div>
        </div>

        <!-- Card principal -->
        <div class="card card-reporte shadow-sm border-0">
            <div class="card-header card-header-reporte text-center text-white border-0">
                <i class="bi bi-heart-pulse-fill me-2"></i>
                <span class="fw-semibold">Reporte de Ubicación y Estado</span>
            </div>

            <div class="card-body p-0">
                <!-- Tabs -->
                <ul class="nav nav-tabs px-3 pt-3 mb-0" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button type="button" class="nav-link" [class.active]="tabActiva === 'general'"
                            (click)="seleccionarTab('general')" role="tab"
                            [attr.aria-selected]="tabActiva === 'general'">
                            <i class="bi bi-bar-chart-fill me-1"></i>
                            Reporte general
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button type="button" class="nav-link" [class.active]="tabActiva === 'vivienda'"
                            (click)="seleccionarTab('vivienda')" role="tab"
                            [attr.aria-selected]="tabActiva === 'vivienda'">
                            <i class="bi bi-house-door-fill me-1"></i>
                            Actualización vivienda principal
                        </button>
                    </li>
                </ul>

                <!-- Contenido tabs -->
                <div class="tab-content p-4">

                    <!-- ===================== TAB: Reporte general ===================== -->
                    <div *ngIf="tabActiva === 'general'" class="tab-pane-content">
                        <label for="cedula" class="form-label fw-semibold mb-2">
                            Identificación del trabajador
                        </label>
                        <div class="input-group input-group-consulta">
                            <span class="input-group-text bg-light border-end-0">
                                <i class="bi bi-person-vcard text-secondary"></i>
                            </span>
                            <input type="text" id="cedula" class="form-control border-start-0"
                                placeholder="Ingrese su cédula..." [(ngModel)]="cedula" (keyup.enter)="consultar()"
                                autocomplete="off" inputmode="numeric" mask="000000000" maxlength="9">
                            <button type="button" class="btn btn-consultar" (click)="consultar()">
                                <i class="bi bi-search me-1"></i>
                                Consultar
                            </button>
                        </div>

                        <!-- Card resultado de la consulta -->
                        <div *ngIf="resultado" class="card card-resultado mt-4 shadow-sm">
                            <div class="card-header card-header-resultado">
                                <i class="bi bi-person-badge me-2"></i>
                                Datos del aprendiz
                            </div>
                            <div class="card-body">
                                <div class="row g-3">
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Cédula</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.cedula) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Nombre</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.nombre) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Apellido</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.apellido) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Género</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.genero) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Fecha de nacimiento</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.fecha_nacimiento) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Edad</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.edad) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Estado</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.estado) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Municipio</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.municipio) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Parroquia</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.parroquia) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="dato-item">
                                            <span class="dato-label">Dirección</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.direccion) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Teléfono</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.telefono) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Correo electrónico</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.correo_electronico)
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Discapacidad</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.discpacidad) }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">RIF</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.rif) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Nombre empresa</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.nombre_empresa) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="dato-item">
                                            <span class="dato-label">Centro de formación</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.nombre_centro_formacion)
                                                }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="dato-item">
                                            <span class="dato-label">Fecha de inicio</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.fecha_inicio) }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="dato-item">
                                            <span class="dato-label">Fecha de egreso</span>
                                            <span class="dato-valor">{{ valorCampo(resultado.fecha_egreso) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Card datos de emergencia -->
                        <div *ngIf="resultado" class="card card-resultado card-emergencia mt-4 shadow-sm">
                            <div class="card-header card-header-resultado">
                                <i class="bi bi-exclamation-octagon me-2"></i>
                                Datos de emergencia
                            </div>
                            <div class="card-body">
                                <div class="row g-4">

                                    <div class="col-12">
                                        <div class="campo-emergencia">
                                            <label for="desaparecido" class="form-label fw-semibold">
                                                1. ¿El Aprendiz del PNA se encuentra desaparecido o no localizado a
                                                causa del evento?
                                            </label>
                                            <select id="desaparecido" class="form-select" [(ngModel)]="desaparecido"
                                                (ngModelChange)="onDesaparecidoChange()">
                                                <option value="" disabled selected>Seleccione una opción</option>
                                                <option *ngFor="let op of opcionesDesaparecido" [value]="op.value">
                                                    {{ op.label }}
                                                </option>
                                            </select>

                                            <div *ngIf="desaparecido === 'si'" class="campos-condicionales mt-3">
                                                <div class="mb-3">
                                                    <label for="ultimaUbicacion" class="form-label">
                                                        Última ubicación conocida o estimada
                                                    </label>
                                                    <textarea id="ultimaUbicacion" class="form-control" rows="3"
                                                        [(ngModel)]="ultimaUbicacion"
                                                        placeholder="Indicar sector, calle o punto de referencia para los equipos de rescate">
                                                    </textarea>
                                                </div>

                                                <div>
                                                    <label for="fotografiaAprendiz" class="form-label">
                                                        Fotografía reciente del Aprendiz
                                                    </label>
                                                    <div class="input-group">
                                                        <input type="file" id="fotografiaAprendiz" class="form-control"
                                                            accept="image/jpeg,image/jpg,image/png"
                                                            (change)="onFotografiaSeleccionada($event)">
                                                    </div>
                                                    <small class="text-muted d-block">
                                                        Formatos permitidos: JPG, JPEG o PNG. Tamaño máximo: 5 MB.
                                                    </small>
                                                    <small *ngIf="fotografiaNombre" class="text-muted d-block">
                                                        Archivo seleccionado: {{ fotografiaNombre }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="campo-emergencia">
                                            <label for="estadoSalud" class="form-label fw-semibold">
                                                2. Estado de Salud del Aprendiz (Reporte General)
                                            </label>
                                            <p class="campo-ayuda mb-2">
                                                De los aprendices contactados, ¿cuál es su estado de salud o condición
                                                física actual?
                                            </p>
                                            <select id="estadoSalud" class="form-select" [(ngModel)]="estadoSalud"
                                                (ngModelChange)="onEstadoSaludChange()">
                                                <option value="" disabled selected>Seleccione una opción</option>
                                                <option *ngFor="let op of opcionesEstadoSalud" [value]="op.value">
                                                    {{ op.label }}
                                                </option>
                                            </select>

                                            <div *ngIf="estadoSalud === 'otro'" class="mt-3">
                                                <label for="estadoSaludOtro" class="form-label">
                                                    Especifique el estado de salud
                                                </label>
                                                <input type="text" id="estadoSaludOtro" class="form-control"
                                                    [(ngModel)]="estadoSaludOtro"
                                                    placeholder="Describa brevemente el estado de salud"
                                                    maxlength="120">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="campo-emergencia">
                                            <label for="estadoVivienda" class="form-label fw-semibold">
                                                3. Estado de la Vivienda del Aprendiz
                                            </label>
                                            <p class="campo-ayuda mb-2">
                                                Enfoque prioritario para aquellos que residen en los Estados declarados
                                                en emergencia.
                                                ¿Cuál es la condición estructural actual de la vivienda del aprendiz?
                                            </p>
                                            <select id="estadoVivienda" class="form-select"
                                                [(ngModel)]="estadoVivienda">
                                                <option value="" disabled selected>Seleccione una opción</option>
                                                <option *ngFor="let op of opcionesEstadoVivienda" [value]="op.value">
                                                    {{ op.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div class="d-flex justify-content-end gap-2 mt-4">
                                    <button type="button" class="btn btn-outline-secondary" (click)="limpiar()">
                                        <i class="bi bi-eraser me-1"></i>
                                        Limpiar
                                    </button>
                                    <button type="button" class="btn btn-enviar-reporte" (click)="enviarReporte()">
                                        <i class="bi bi-send-fill me-1"></i>
                                        Enviar reporte
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ===================== TAB: Actualización vivienda principal ===================== -->
                    <div *ngIf="tabActiva === 'vivienda'" class="tab-pane-content">

                        <div class="aviso-vivienda mb-4">
                            Este módulo es para personas que ya registraron su censo y necesitan actualizar el estado de
                            su vivienda principal.
                        </div>

                        <label for="cedulaVivienda" class="form-label fw-semibold mb-2">
                            Cédula del aprendiz
                        </label>
                        <div class="input-group input-group-consulta">
                            <input type="text" id="cedulaVivienda" class="form-control"
                                placeholder="Ingrese su cédula..." [(ngModel)]="cedulaVivienda"
                                (keyup.enter)="consultarVivienda()" autocomplete="off" inputmode="numeric"
                                mask="000000000" maxlength="9">
                            <button type="button" class="btn btn-consultar" (click)="consultarVivienda()">
                                <i class="bi bi-search me-1"></i>
                                Consultar
                            </button>
                        </div>

                        <div *ngIf="cedulaViviendaValidada" class="mensaje-validado mt-2">
                            <i class="bi bi-check-circle-fill me-1"></i>
                            Cédula validada. Puede continuar con la actualización.
                        </div>

                        <!-- Referencia del último reporte -->
                        <div *ngIf="cedulaViviendaValidada && resultadoVivienda" class="card card-referencia mt-4">
                            <div class="card-body">
                                <h6 class="referencia-titulo mb-3">
                                    <i class="bi bi-info-circle me-1"></i>
                                    Referencia del último reporte registrado
                                </h6>
                                <div class="row g-2">
                                    <div class="col-12">
                                        <span class="ref-label">Trabajador:</span>
                                        <span class="ref-valor">{{ nombreCompleto(resultadoVivienda) }}</span>
                                    </div>
                                    <div class="col-12">
                                        <span class="ref-label">Condición de vivienda reportada:</span>
                                        <span class="ref-valor">
                                            {{ etiquetaEstadoVivienda(resultadoVivienda.ultimo_reporte?.estado_vivienda)
                                            }}
                                        </span>
                                    </div>
                                    <!--div class="col-12">
                                        <span class="ref-label">¿Corresponde a vivienda principal?:</span>
                                        <span class="ref-valor">—</span>
                                    </div>
                                    <div class="col-12">
                                        <span class="ref-label">Tipo vivienda (caracterización):</span>
                                        <span class="ref-valor">—</span>
                                    </div-->
                                    <div class="col-12">
                                        <span class="ref-label">Dirección registrada:</span>
                                        <span class="ref-valor">{{ valorCampo(resultadoVivienda.direccion) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Formulario de actualización -->
                        <div *ngIf="cedulaViviendaValidada" class="mt-4">
                            <div class="mb-3">
                                <label for="afectacionVivienda" class="form-label fw-semibold">
                                    1. ¿Qué afectaciones recibió su vivienda principal?
                                </label>
                                <select id="afectacionVivienda" class="form-select"
                                    [(ngModel)]="afectacionVivienda"
                                    (ngModelChange)="onAfectacionViviendaChange()">
                                    <option value="" disabled selected>Seleccione una opción...</option>
                                    <option *ngFor="let op of opcionesAfectacionVivienda" [value]="op.value">
                                        {{ op.label }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-4" *ngIf="afectacionVivienda">
                                <label for="estatusViviendaPrincipal" class="form-label fw-semibold">
                                    2. Estatus de vivienda principal
                                </label>
                                <select id="estatusViviendaPrincipal" class="form-select"
                                    [(ngModel)]="estatusViviendaPrincipal"
                                    (ngModelChange)="onEstatusViviendaChange()">
                                    <option value="" disabled selected>Seleccione una opción...</option>
                                    <option *ngFor="let op of opcionesEstatusFiltradas" [value]="op.value">
                                        {{ op.label }}
                                    </option>
                                </select>
                            </div>

                            <!-- 3. Fotos obligatorias si no es habitable -->
                            <div *ngIf="requiereFotosVivienda" class="seccion-fotos-vivienda mb-4">
                                <h6 class="fw-semibold mb-1">
                                    3. Cargar fotos de la vivienda con descripción
                                </h6>
                                <p class="text-muted small mb-3">
                                    Las 3 fotos y su descripción son obligatorias cuando el estatus no es habitable.
                                </p>

                                <div class="row g-3">
                                    <div class="col-md-4" *ngFor="let foto of fotosVivienda; let i = index">
                                        <div class="foto-vivienda-item">
                                            <label class="form-label fw-semibold">Foto {{ i + 1 }}</label>
                                            <input
                                                type="file"
                                                class="form-control mb-2"
                                                accept="image/jpeg,image/jpg,image/png"
                                                (change)="onFotoViviendaSeleccionada($event, i)">
                                            <small *ngIf="foto.nombre" class="text-muted d-block mb-2">
                                                {{ foto.nombre }}
                                            </small>
                                            <label class="form-label">Descripción</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                [(ngModel)]="foto.descripcion"
                                                [name]="'descFoto' + i"
                                                [placeholder]="foto.placeholder"
                                                maxlength="200">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end gap-2">
                                <button type="button" class="btn btn-outline-secondary" (click)="limpiarVivienda()">
                                    <i class="bi bi-eraser me-1"></i>
                                    Limpiar
                                </button>
                                <button type="button" class="btn btn-guardar-vivienda"
                                    (click)="guardarActualizacionVivienda()">
                                    <i class="bi bi-house-check-fill me-1"></i>
                                    Guardar actualización de vivienda
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje">
</app-modal>